import API from '@/services/request/page';
import types from './types';

const api = new API();
const actions = {};

actions.get = ({ commit }, { pageIdentifier, filters = {} }) =>
  api.metrics(pageIdentifier, {
    catchError: true,
    params: {
      paginationPage: 1,
      limit: 3,
      ...filters,
    },
  })
  .then((response) => {
    commit(types.GET_METRICS, response.data);
    return { data: response.data, status: response.status };
  }).catch(error => ({
    data: error.response.data,
    status: error.response.status,
  }));

actions.getChartData = ({ commit }, { pageIdentifier, filters }) =>
  api.chartData(pageIdentifier, { catchError: true, params: filters })
    .then((response) => {
      commit(types.SET_CHART_DATA, { data: response.data, filters });
    });

actions.resetChartData = ({ commit }) => {
  commit(types.RESET_CHART_DATA);
};

export default actions;



// WEBPACK FOOTER //
// ./src/screens/Metrics/store/actions.js